import { render, staticRenderFns } from "./wIndicator.vue?vue&type=template&id=4e9887ec&scoped=true&"
import script from "./wIndicator.vue?vue&type=script&lang=js&"
export * from "./wIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9887ec",
  null
  
)

export default component.exports